import { filterTabs } from "../constants";

interface SortBarProps {
  activeSort: number;
  onChange: (index: number) => void;
}

export default function SortBar({ activeSort, onChange }: SortBarProps) {
  return (
    <div className="flex border-t border-gray-100">
      {filterTabs.map((tab, i) => (
        <button
          key={tab}
          onClick={() => onChange(i)}
          className="flex-1 py-2.5 text-xs font-medium cursor-pointer whitespace-nowrap transition-colors"
          style={{
            color: activeSort === i ? "#1E3A8A" : "#6B7280",
            borderBottom: activeSort === i ? "2px solid #1E3A8A" : "2px solid transparent",
          }}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
